<template>
  <b-card no-body class="card-list-job bg-secondary border-0 my-3">
    <b-card-header class="bg-transparent pb-2 border-0">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="mb-0">งานที่กำลังทำ</h3>
      </div>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <TableListJob
            :items="items"
            :search="search"
            @changePage="$emit('changePage', $event)" />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import TableListJob from "@/components/Home/TableListJob.vue";

export default {
  components: { TableListJob },
  props: {
    search: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
